module.exports = __webpack_public_path__ + "static/nasa3-4262ce384404134275895830529b5a77.gif";